'use strict';

const ADDRESS_VALIDATION_ERROR = {
    PO_BOX_UNSUPPORTED: 'address_validation.invalid_po_box',
    ADDRESS_REGION_NOT_SUPPORTED: 'address_validation.invalid_territory_unsupported',
    INVALID: 'address_validation.invalid_error',
    SERVICE_ERROR: 'address_validation.service_error'
};

function addressValidationErrorContentKey(error) {
    if (!error) {
        return '';
    }

    let contentKey = ADDRESS_VALIDATION_ERROR[error];
    if (!contentKey) {
        console.warn('Error content not found:' + contentKey);
        contentKey = ADDRESS_VALIDATION_ERROR.INVALID;
    }

    return contentKey;
}

/**
 * Defines formats for interpolation variables that are localised by griffin instead of by the L10N team.
 *
 * Currencies:
 * {$0}=0
 * {$0.00}=$0.00
 * {$3c95}=$3.95
 *
 * Percentages:
 * {%5}=5%
 * {%2pt5}=2.5%
 */
function griffinKeyCreator (griffinNumberHandler) {
    var griffinNumber = griffinNumberHandler;

    /**
     * @param obj Object to insert property into. This is usually the interpolation object passed as i18n()'s second param.
     * @param pcValue {Number|String}
     */
    function insertLocalisedPercentageProperty (obj, pcValue) {
        const wholeNumber = parseInt(pcValue);
        const decimalValue = pcValue % 1;

        let decimalPart = decimalValue ? String(decimalValue).replace('0.', 'pt') : '';
        obj['%' + wholeNumber + decimalPart] = getLocalisedPercentage(pcValue);
        return obj;
    }

    function getLocalisedPercentage (value) {
        return griffinNumber.formatNumber(value / 100, {style: 'percent'});
    }

    /**
     * cents is optional
     */
    function insertLocalisedCurrencyProperty (obj, amtString) {
        const splits = amtString.split('.');
        const dollars = splits[0];
        const cents = splits[1];
        const noCents = cents === undefined;

        obj['$' + dollars + (cents ? 'c' + cents : '')] = getLocalisedCurrency(dollars, cents, noCents);
        return obj;
    }

    /**
     * cents is optional
     */
    function getLocalisedCurrency (dollars, cents, noCents) {
        const currencyFormat = griffinNumber.CURRENCY_FORMAT;
        if (noCents) {
            currencyFormat.maximumFractionDigits = 0;
        }
        return griffinNumber.formatCurrency({
            value: Number(dollars) + (cents ? (cents / 100) : 0),
            currency: 'USD'
        }, currencyFormat);
    }

    return {
        insertLocalisedPercentageProperty,
        insertLocalisedCurrencyProperty
    };
}

module.exports = {
    addressValidationErrorContentKey: addressValidationErrorContentKey,
    griffinKeyCreator
};



/** WEBPACK FOOTER **
 ** ./public/js/utils/content.js
 **/